// extracted by mini-css-extract-plugin
export default {"title":"UpdateChanges-title-iaqWz"};